const actionType = {
    GET_ALL_GROUP_SETUPS_SUCCESS: 'GET_ALL_GROUP_SETUPS_SUCCESS',
    GET_GROUP_FIELD_CONFIGURATIONS_SUCCESS: 'GET_GROUP_FIELD_CONFIGURATIONS_SUCCESS',
    GET_GROUP_FIELD_LINK_CONFIGURATIONS_SUCCESS: 'GET_GROUP_FIELD_LINK_CONFIGURATIONS_SUCCESS',
    GET_ALL_GROUP_SOURCE_FIELD_MAPPING_SUCCESS: 'GET_ALL_GROUP_SOURCE_FIELD_MAPPING_SUCCESS',
    SELECTED_SOURCE_NAMES_CONFIG: 'SELECTED_SOURCE_NAMES_CONFIG',
    RESET_MAPPED_DATA_DICTIONARY: 'RESET_MAPPED_DATA_DICTIONARY',
    GET_GROUP_DD_CONFIGS: 'GET_GROUP_DD_CONFIGS',
    GET_GC_RULE_NAMES: 'GET_GC_RULE_NAMES',
    SET_ACTIVE_GROUP_INDEX: 'SET_ACTIVE_GROUP_INDEX',
    GET_GROUP_SETTINGS: 'GET_GROUP_SETTINGS',
};
export default actionType;
